<template>
    <!--<div class="sliderbarbox" :class="{'is-show':show}" @click="toggle" ref="sidebarCart">
        <header>
            <span>{{taxonomyText}}</span>
            <el-button @click="deleteAll" size="small" round :disabled="deleting">一键清空</el-button>
        </header>
        <div class="allshop" v-loading="loading && !dataSource[taxonomy].length">
            <ul v-if="dataSource[taxonomy].length">
                <li v-for="(item,i) in dataSource[taxonomy]" :key='i' class="sliderli">
                    <img :src="item.thumb" alt="">
                    <div>
                        <p class="item-title">{{item.subject}}</p>
                        <p class="item-price">
                            <span class="price" style="margin-right:12px">￥{{item.price}}</span>[{{item.type_text}}]</p>
                    </div>
                    <i class="el-icon-circle-close error" @click="deleted(item.item_id)"></i>
                </li>
            </ul>

            <Empty type="cart" text="没有媒体" v-if="!dataSource[taxonomy].length" />

        </div>
        <ul class="taxonomy-selecter">
            <li v-for="(v,i) in taxonomies" :key="i" :class="taxonomy==i?  'active pointer '+i:'pointer '+i" @click="load(i)" >
                <span v-show="dataSource[i].length">{{dataSource[i].length}}</span>
            </li>
        </ul>
        <footer>
            <div class="has-selected">
                <span>已选媒体
                    <span class="price"> {{dataSource[taxonomy].length}} </span>个</span>
                <span>金额
                    <span class="price"> ￥{{money}}元 </span>
                </span>
            </div>
            <div>
                <span class="exprotsspan pointer" @click="exports">
                    <img src="../../assets/exprots.png" alt="" style="width:17px;height:15px;">导出</span>
                <el-button @click="$router.push('/cart?taxonomy='+taxonomy)" type="primary" size="medium" class="pulsate-bck">跳转到购物车</el-button>
            </div>
        </footer>
        <div class="sliderborder">
            <ul>
                <el-tooltip class="item" content="联系客服" placement="left">
                    <li>
                        &lt;!&ndash; <i class="iconfont icon-kefu1"></i>  &ndash;&gt;
                        <a class="sliderbar_icon" :href="config.chat_url" target="_blank"></a>
                    </li>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="购物车" placement="left">
                    <li class="cart" id="global-cart-in">
                            <i class="iconfont icon-gouwuche2" style="margin-bottom:8px"></i>
                        <span>{{dataSource[taxonomy].length}}</span>
                    </li>
                </el-tooltip>
                <el-tooltip class="item" content="QQ客服" placement="left" transition="">
                    <li>
                        &lt;!&ndash; <i  class="iconfont icon-qq"></i> &ndash;&gt;
                        <a class="sliderbar_icon" target="_blank" :href="config.chat_url"></a>
                    </li>
                </el-tooltip>
                &lt;!&ndash; <el-tooltip class="item" content="公告" placement="left" transition="">
          <li>

            <span class="sliderbar_icon pointer"></span>

          </li>
        </el-tooltip> &ndash;&gt;

            </ul>
            <ul>
                <el-tooltip class="item" content="返回顶部" placement="left" transition="">
                    <li @click="goback">

                        &lt;!&ndash; <i  class="iconfont icon-jiantoushang"></i> &ndash;&gt;
                        <span class="sliderbar_icon"></span>

                    </li>
                </el-tooltip>
                &lt;!&ndash; <el-tooltip class="item" content="反馈意见" placement="left" transition="">
          <li>
            <span class="sliderbar_icon"></span>
          </li>
        </el-tooltip> &ndash;&gt;
            </ul>
        </div>
        <el-dialog title="导出购物车·" :visible.sync="showExport" width="422">

        </el-dialog>
        &lt;!&ndash; <div v-else style="font-size:12px;text-align:center;padding-top:">购物车空空的，赶快去挑选心仪的媒体吧~<br/> <router-link to="/resource/news" style="font-size:12px;color:#ff8900">去媒体中看看</router-link> </div> &ndash;&gt;
    </div>-->

</template>


<script>
    export default {
        data() {
            return {
                taxonomyText: "购物车",
                hasToggle: false,
                show: false,
                showExport: false,
                time: 60,
                deleting: false
            };
        },
        watch: {
            taxonomy(v) {
                switch (this.taxonomy) {
                    case "woa":
                        this.taxonomyText = "微信公众号";
                        break;
                    case "weibo":
                        this.taxonomyText = "微博";
                        break;
                    case "video":
                        this.taxonomyText = "短视频";
                        break;
                    case "live":
                        this.taxonomyText = "直播";
                        break;
                    case "flow":
                        this.taxonomyText = "信息流";
                        break;
                    case "news":
                        this.taxonomyText = "软文推广";
                        break;
                    case "xhs":
                        this.taxonomyText = "小红书";
                        break;
                }
            }
        },
        mounted() {  },
        computed:{
            dataSource(){
                return this.$store.state.cart
            },
            loading(){
                return this.$store.state.cartLoading
            },
            taxonomy(){
                return this.$store.state.cartTaxonomy
            },
            taxonomies(){
                return this.$store.state.taxonomy
            },
            money(){
                var money = 0;
                this.dataSource[this.taxonomy].forEach(element => {
                   money += parseInt(element.price);
                 });
                return  money.toFixed(2);
            }
        },
        methods: {
            load(taxonomy){
                this.$event_bus.$emit(taxonomy+'CartLoad')
                this.$store.commit('changeCartTaxonomy',taxonomy)
            },
            toggle(e) {
                this.hasToggle = true;
                this.show = !this.show;
            },
            exports() {
                this.$confirm("您确定要导出当前购物车里的媒体吗？", "提示", {
                    confirmButtonText: "确定",
                    showClose: false,
                    closeOnPressEscape: false,
                    callback: action => {
                        if (action == "confirm") {
                            this.$http
                                .post("/cart/export?taxonomy=" + this.taxonomy)
                                .then(res => {
                                    if (res.success) {
                                        window.location.href = res.data.url;
                                    } else {
                                        this.$confirm(res.message, "导出失败", {
                                            confirmButtonText: "确定",
                                            showCancelButton: false,
                                            type: "error"
                                        });
                                    }
                                });
                        }
                    }
                });
            },
            alert(val) {
                this.$msgbox({
                    title: "导出成功",
                    closeOnClickModal: false,
                    showCancelButton: false,
                    closeOnPressEscape: false,
                    message: "<a href=" + val + "  >导出成功，点击下载</a>",
                    dangerouslyUseHTMLString: true,
                    showCancelButton: false,
                    confirmButtonText: "确定"
                });
            },
            deleted(item_id) {
                this.deleting = true;
                this.$http
                    .delete("/cart/" + item_id)
                    .then(response => {
                        if (response.success) {
                            this.load(this.taxonomy);
                            this.$emit("reload");
                        }
                    })
                    .catch()
                    .then(() => {
                        this.deleting = false;
                    });
            },
            goback() {
                (function smoothscroll() {
                    var currentScroll =
                        document.documentElement.scrollTop || document.body.scrollTop;
                    if (currentScroll > 0) {
                        window.requestAnimationFrame(smoothscroll);
                        window.scrollTo(0, currentScroll - currentScroll / 5);
                    }
                })();
            },
            openqq() {
                //打开qq在线交谈
                window.open(
                    "http://b.qq.com/webc.htm?new=0&sid=2852688748&o=快传播&q=7",
                    "_blank",
                    "height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no"
                );
            },
            deleteAll() {
                var cart_arr = [];
                var cart_ids = "";
                this.dataSource[this.taxonomy].forEach(element => {
                    if (this.dataSource[this.taxonomy].length > 0) {
                        cart_arr.push(element.item_id);
                        cart_ids = cart_arr.join(",");
                    }
                });
                this.deleting = true;
                this.$http
                    .delete("/cart/" + cart_ids)
                    .then(response => {
                        if (response.success) {
                            this.$emit("reload");
                            this.load(this.taxonomy);
                        }
                    })
                    .catch()
                    .then(() => {
                        this.deleting = false;
                    });
            }
        }
    };

</script>


<style scoped lang="scss">
    @import "../../../config.scss";

    .item-title {
        height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 4px 0;
        font-size: 14px;
    }

    .item-price {
        margin: 0;
        font-size: 12px;
        color:#9E9E9E
    }

    .taxonomy-selecter {
        display: flex;
        height: 62px;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        width: 100%;
        bottom: 80px;
    }

    .taxonomy-selecter>li{
        width: 24px;
        height: 24px;
        background-size: cover !important;
    }

    .taxonomy-selecter>li.woa{
        background: url("https://static.711.cn/material/icon/v2/woa_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.woa.active {
        background: url("https://static.711.cn/material/icon/v2/woa.png") no-repeat;
    }

    .taxonomy-selecter>li.video {
        background: url("https://static.711.cn/material/icon/v2/video_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.video.active {
        background: url("https://static.711.cn/material/icon/v2/video.png") no-repeat;
    }

    .taxonomy-selecter>li.news {
        background: url("https://static.711.cn/material/icon/v2/news_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.news.active {
        background: url("https://static.711.cn/material/icon/v2/news.png") no-repeat;
    }

    .taxonomy-selecter>li.weibo {
        background: url("https://static.711.cn/material/icon/v2/weibo_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.weibo.active {
        background: url("https://static.711.cn/material/icon/v2/weibo.png") no-repeat;
    }

    .taxonomy-selecter>li.live {
        background: url("https://static.711.cn/material/icon/v2/live_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.live.active {
        background: url("https://static.711.cn/material/icon/v2/live.png") no-repeat;
    }

     .taxonomy-selecter>li.xhs {
        background: url("https://static.711.cn/material/icon/v2/xhs_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.xhs.active {
        background: url("https://static.711.cn/material/icon/v2/xhs.png")  no-repeat;
    }

    .taxonomy-selecter>li>span {
        width: 18px;
        height: 18px;
        display: inline-block;
        background-color: #999999;
        color: #ffffff;
        line-height: 18px;
        text-align: center;
        border-radius: 50%;
        margin-top: -4px;
        margin-left: 20px;
        font-size: 12px;
        vertical-align: top;
    }

    .taxonomy-selecter>li.active>span {
        background: $--color-primary;
    }

    .error {
        cursor: pointer;
        font-size: 16px;
        color: #9E9E9E;
    }

    .allshop {
        overflow-y: auto;
        position: absolute;
        width: 100%;
        top: 70px;
        bottom: 140px;
    }

    .sliderbarbox {
        height: 100%;
        position: fixed;
        right: -280px;
        width: 280px;
        top: 0;
        background: #fff;
        transition: 0.3s;
        z-index: 10;

        /* border-left: 6px solid #7a6e6e; */
    }

    .sliderbarbox.is-show {
        transform: translate(-280px);
    }

    .sliderli {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 8px;
        margin-top: 5px;
    }

    .sliderli>img {
        width: 12px;
        height: 12px;
        margin-top: 15px;
    }

    .sliderli>img:first-child {
        width: 40px;
        height: 40px;
        margin-top: 0px;
        border-radius: 50%;
    }

    .sliderli>div {
        width: 180px;
        padding-top: 3px;
    }

    header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 67px;
        padding-left: 12px;
        padding-right: 12px;
        border-bottom: 1px solid #eeeeee;
    }

    header>span:first-child {
        font-size: 16px;
    }

    header>span:nth-child(2) {
        cursor: pointer;
        height: 30px;
        border-radius: 3px;
        background-color: #3aa0e7;
        color: #fff;
        padding: 4px 10px;
        line-height: 30px;
    }

    footer {
        width: 100%;
        position: absolute;
        bottom: 0px;
        border-top: 1px solid #eaeaea;
        padding-bottom: 12px;
        padding-top: 12px;
    }

    footer>div>button {
        width: 164px;
        margin-top: 16px;
    }

    footer>div>span {
        display: inline-block;
        color: #999999;
        margin-left: 20px;
        margin-right: 18px;
        font-size: 12px;
    }

    footer>.has-selected {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    footer>p {
        display: flex;
        height: 30px;
        line-height: 30px;
    }

    footer>p>span {
        width: 50%;
        text-align: center;
    }

    .sliderborder>ul:nth-child(1) {
        position: absolute;
        top: 26%;
        width: 100%;
    }

    .sliderborder>ul>li {
        width: 100%;
        display: flex;
        height: 42px;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
    }

    .sliderborder>ul>li:hover {
        background: $--color-primary;
    }

    .sliderborder>ul:nth-child(2) {
        position: absolute;
        bottom: 20px;
        /* top: 0; */
        width: 100%;
    }

    .sliderborder>ul:nth-child(2)>li {
        width: 100%;
        height: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .sliderborder>ul:nth-child(2)>li:nth-child(1) .sliderbar_icon {
        background: url("../../img/sliderbar.png") no-repeat center;
        background-position: 0 -206px;
    }

    .sliderborder>ul:nth-child(2)>li:nth-child(2) .sliderbar_icon {
        background: url("../../img/sliderbar.png") no-repeat center;
        background-position: 0 -257px;
    }

    .sliderborder{
        color: #ffffff;
        position: absolute;
        /* top: 40%; */
        top: 0;
        left: -42px;
        background: #3b3c39;
        width: 42px;
        height: 100%;
        box-shadow: -3px 0px 12px 0 rgba(0, 0, 0, 0.15);
        :hover {
            cursor: pointer;
        }
        .cart {
            padding-top: 24px;
            padding-bottom: 24px;
            height: 60px;
            display: flex;
            background-color: #222429;
            justify-content: center;
            flex-direction: column;
            align-items: center;
        }
        .cart>span {
            border-radius: 50%;
            background-color: $--color-primary;
            color: #fff;
            width: 21px;
            height: 21px;
            line-height: 21px;
            text-align: center;
            font-size: 12px;
        }
        .cart>p {
            word-wrap: break-word;
            width: 14px;
            font-size: 14px;
        }
    }

    .sliderborder>ul>li.cart:hover,.sliderborder>ul>li.cart.active {
        background-color: $--color-primary;
    }

    .sliderborder>ul>li.cart:hover>span,.sliderborder>ul>li.cart.active>span {
        background-color: #ffffff;
        color: $--color-primary;
    }


    .iconfont {
        color: #fff;
        font-size: 24px;
    }

    .sliderbar_icon {
        display: inline-block;
        width: 25px;
        height: 25px;
    }

    .sliderborder>ul>li:nth-child(1) .sliderbar_icon {
        background: url("../../img/sliderbar.png") no-repeat center;
        background-position: 0 0;
    }

    .sliderborder>ul>li:nth-child(2) .sliderbar_icon {
        background: url("../../img/sliderbar.png") no-repeat center;
        background-position: 0 -52px;
    }

    .sliderborder>ul>li:nth-child(3) .sliderbar_icon {
        background: url("../../img/sliderbar.png") no-repeat center;
        background-position: 0 -102px;
    }

    .sliderborder>ul>li:nth-child(4) .sliderbar_icon {
        background: url("../../img/sliderbar.png") no-repeat center;
        background-position: 0 -156px;
    }

    .item-desc {
        font-size: 12px;
    }


/**
 * ----------------------------------------
 * animation wobble-hor-bottom
 * ----------------------------------------
 */

 .cart.shake>i {
	-webkit-animation: shake-bottom 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
	        animation: shake-bottom 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
}
@-webkit-keyframes shake-bottom {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
    -webkit-transform-origin: 50% 100%;
            transform-origin: 50% 100%;
  }
  10% {
    -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
            transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
            transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
            transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
  }
}
@keyframes shake-bottom {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
    -webkit-transform-origin: 50% 100%;
            transform-origin: 50% 100%;
  }
  10% {
    -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
            transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
            transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
            transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
  }
}


</style>



// WEBPACK FOOTER //
// src/components/global/sidebar.vue